import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {NineToFive} from "../../NineToFive";
import {gsap} from "gsap";
import {NineToFiveSymbol} from "../../reels/symbols/NineToFiveSymbol";
import {GSAPUtils} from "../../utils/GSAPUtils";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {LawSuitSymbol} from "../../reels/symbols/LawSuitSymbol";

/**
 * Created by jonas on 2022-09-02.
 */
export class FreeSpinLawsuits implements SimplePresentation {

    name:string = "FreeSpinLawsuits";

    constructor() {
    }

    shouldRun():boolean {
        return this.getLawsuitSymbols().length > 0;
    }

    private getLawsuitSymbols():LawSuitSymbol[] {
        return <LawSuitSymbol[]>NineToFive.baseGameReelView.getAllSymbols().filter((sym) => sym.symbolName == "MN");
    }

    start(controller:SimplePresentationRunnerController):void {
        const cantGoLower = NineToFive.baseGameReelView.freespinMultiplier.multiplier == 1;
        const tl = gsap.timeline({
            onStart: () => {
                controller.setSkipCallback(() => tl.seek("End", false));
            },
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish()
            }
        })
            .add(GSAPUtils.createTimelineFromArray(this.getLawsuitSymbols().map((sym) =>
                gsap.timeline()
                    .add(sym.getWinAnimationBased())
                    .add(NineToFive.model.gameData.mode == GameMode.FREESPIN
                        ? sym.minusOne()
                        : sym.reset(), '<')
                    .add(() => {NineToFive.soundPlayer.playSound("multiplierNegativeActivation")}, '<')
                    .addLabel("End")
                    .add(NineToFive.model.gameData.mode == GameMode.FREESPIN
                        ? NineToFive.baseGameReelView.freespinMultiplier.decrement()
                        : NineToFive.baseGameReelView.freespinMultiplier.decrementSfsNext(), '<')
                    .add(cantGoLower
                        ? () => { NineToFive.soundPlayer.playSound("multiplierCounterError") }
                        : () => { NineToFive.soundPlayer.playSound("multiplierCounterUpdate") }, '<')
            ), '>'))
            //.add(() => {}, '>0.3');
    }
}
